var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _g, _path3, _g2, _rect44, _path4, _g3, _path5, _rect45, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadFinderUpsell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 89,
    viewBox: "0 0 136 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.387 83.7148L9.61512 70.5807C5.79544 69.794 4.6252 64.91 7.6736 62.4777L23.1572 50.1235C23.8315 49.5854 24.6436 49.2478 25.5007 49.1491L82.6837 42.5667C83.4426 42.4793 84.2114 42.5823 84.9205 42.8664L123.809 58.4419C127.764 60.0262 127.627 65.6719 123.599 67.0623L75.8165 83.5575C75.0355 83.8271 74.1963 83.8815 73.387 83.7148Z",
    fill: "url(#paint0_linear_3572_21516)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5029 33.2984V67.8631H97.5642V42.0122H93.7887V36.4934H90.594V42.0122H86.5281V33.2984H83.6238V26.9083H81.1552V20.8086H76.218V26.9083H74.3303V33.2984H71.1356V25.6012H69.5383V21.68H68.667V25.6012H63.0037V50.8712H58.5022V47.8214H56.4692V50.8712H51.9676V42.0122H43.8358V36.4934H41.0767V52.9044H36.8656V46.5143H33.0901V52.9044H29.3146V33.2984H26.9912V26.9083H16.5359V33.2984H14.5029Z",
    fill: "#C4D1F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.8267,
    y: 28.3594,
    width: 1.74255,
    height: 4.06645,
    fill: "#E7EAF2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9551,
    y: 35.6211,
    width: 3.48509,
    height: 2.03323,
    fill: "#E7EAF2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0869,
    y: 35.6211,
    width: 3.48509,
    height: 2.03323,
    fill: "#E7EAF2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9551,
    y: 39.6914,
    width: 3.48509,
    height: 2.03322,
    fill: "#E7EAF2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0869,
    y: 39.6914,
    width: 3.48509,
    height: 2.03322,
    fill: "#E7EAF2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9551,
    y: 51.8867,
    width: 3.48509,
    height: 2.03322,
    fill: "#E7EAF2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0869,
    y: 51.8867,
    width: 3.48509,
    height: 2.03322,
    fill: "#E7EAF2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9551,
    y: 43.7539,
    width: 3.48509,
    height: 2.03322,
    fill: "#E7EAF2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0869,
    y: 43.7539,
    width: 3.48509,
    height: 2.03322,
    fill: "#E7EAF2"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9551,
    y: 55.957,
    width: 3.48509,
    height: 2.03322,
    fill: "#E7EAF2"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0869,
    y: 55.957,
    width: 3.48509,
    height: 2.03322,
    fill: "#E7EAF2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9551,
    y: 47.8203,
    width: 3.48509,
    height: 2.03322,
    fill: "#E7EAF2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0869,
    y: 47.8203,
    width: 3.48509,
    height: 2.03322,
    fill: "#E7EAF2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 15.9551,
    y: 60.0234,
    width: 3.48509,
    height: 2.03321,
    fill: "#E7EAF2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 24.0869,
    y: 60.0234,
    width: 3.48509,
    height: 2.03321,
    fill: "#E7EAF2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7666,
    y: 54.793,
    width: 8.71272,
    height: 1.16184,
    fill: "#E7EAF2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 53.1294,
    y: 55.1055,
    width: 8.13188,
    height: 1.08438,
    fill: "#E7EAF2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7666,
    y: 58.2773,
    width: 8.71272,
    height: 1.16184,
    fill: "#E7EAF2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 53.1294,
    y: 58.3555,
    width: 8.13188,
    height: 1.08438,
    fill: "#E7EAF2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7666,
    y: 61.7656,
    width: 8.71272,
    height: 1.16186,
    fill: "#E7EAF2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7666,
    y: 56.5352,
    width: 8.71272,
    height: 1.16184,
    fill: "#E7EAF2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 53.1294,
    y: 56.7305,
    width: 8.13188,
    height: 1.08438,
    fill: "#E7EAF2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7666,
    y: 60.0234,
    width: 8.71272,
    height: 1.16184,
    fill: "#E7EAF2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 30.7666,
    y: 63.5078,
    width: 8.71272,
    height: 1.16184,
    fill: "#E7EAF2"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6738,
    y: 43.7539,
    width: 2.3234,
    height: 3.48552,
    fill: "#E7EAF2"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6113,
    y: 43.7539,
    width: 2.3234,
    height: 3.48552,
    fill: "#E7EAF2"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6738,
    y: 48.9805,
    width: 2.3234,
    height: 3.48552,
    fill: "#E7EAF2"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6113,
    y: 48.9805,
    width: 2.3234,
    height: 3.48552,
    fill: "#E7EAF2"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6738,
    y: 54.2109,
    width: 2.3234,
    height: 3.48552,
    fill: "#E7EAF2"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6113,
    y: 54.2109,
    width: 2.3234,
    height: 3.48552,
    fill: "#E7EAF2"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 42.6738,
    y: 59.4375,
    width: 2.3234,
    height: 3.48552,
    fill: "#E7EAF2"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 47.6113,
    y: 59.4375,
    width: 2.3234,
    height: 3.48552,
    fill: "#E7EAF2"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 63.0039,
    y: 27.4883,
    width: 3.19466,
    height: 4.06644,
    fill: "#E7EAF2"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 93.7886,
    y: 44.3359,
    width: 3.77551,
    height: 4.64736,
    fill: "#E7EAF2"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1685,
    y: 35.9141,
    width: 11.3265,
    height: 3.19507,
    fill: "#E7EAF2"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1685,
    y: 43.1719,
    width: 11.3265,
    height: 3.19506,
    fill: "#E7EAF2"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1567,
    y: 50.8789,
    width: 11.3265,
    height: 3.19506,
    fill: "#E7EAF2"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1685,
    y: 57.9883,
    width: 11.3265,
    height: 3.19506,
    fill: "#E7EAF2"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 93.7886,
    y: 51.3086,
    width: 3.77551,
    height: 4.64735,
    fill: "#E7EAF2"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 93.7886,
    y: 58.5664,
    width: 3.77551,
    height: 4.64736,
    fill: "#E7EAF2"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 63.0039,
    y: 33.2969,
    width: 3.19466,
    height: 4.06644,
    fill: "#E7EAF2"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 63.0039,
    y: 39.1094,
    width: 3.19466,
    height: 4.06644,
    fill: "#E7EAF2"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 63.0039,
    y: 44.918,
    width: 3.19466,
    height: 4.06645,
    fill: "#E7EAF2"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 63.0039,
    y: 50.7266,
    width: 3.19466,
    height: 4.06644,
    fill: "#E7EAF2"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 63.0039,
    y: 56.5352,
    width: 3.19466,
    height: 4.06643,
    fill: "#E7EAF2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3572_21516)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-48-inside-1_3572_21516",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.237 10.5234C75.3567 10.5234 73.8325 12.0477 73.8325 13.9279C73.8325 15.6882 75.1685 17.1364 76.8817 17.314L78.2027 19.0742C78.5707 19.5646 79.3066 19.5646 79.6747 19.0742L80.9956 17.314C82.7088 17.1363 84.0446 15.6881 84.0446 13.9279C84.0446 12.0477 82.5204 10.5234 80.6401 10.5234H77.237Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.237 10.5234C75.3567 10.5234 73.8325 12.0477 73.8325 13.9279C73.8325 15.6882 75.1685 17.1364 76.8817 17.314L78.2027 19.0742C78.5707 19.5646 79.3066 19.5646 79.6747 19.0742L80.9956 17.314C82.7088 17.1363 84.0446 15.6881 84.0446 13.9279C84.0446 12.0477 82.5204 10.5234 80.6401 10.5234H77.237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8817 17.314L77.0657 17.1759L77.0054 17.0956L76.9055 17.0852L76.8817 17.314ZM78.2027 19.0742L78.0187 19.2122L78.2027 19.0742ZM79.6747 19.0742L79.8587 19.2122L79.6747 19.0742ZM80.9956 17.314L80.9719 17.0852L80.8719 17.0955L80.8116 17.1759L80.9956 17.314ZM74.0626 13.9279C74.0626 12.1747 75.4838 10.7535 77.237 10.7535V10.2934C75.2297 10.2934 73.6025 11.9206 73.6025 13.9279H74.0626ZM76.9055 17.0852C75.3082 16.9196 74.0626 15.5691 74.0626 13.9279H73.6025C73.6025 15.8072 75.0287 17.3532 76.858 17.5429L76.9055 17.0852ZM76.6977 17.4521L78.0187 19.2122L78.3867 18.9361L77.0657 17.1759L76.6977 17.4521ZM78.0187 19.2122C78.4788 19.8254 79.3986 19.8254 79.8587 19.2122L79.4907 18.9361C79.2146 19.3039 78.6627 19.3039 78.3867 18.9361L78.0187 19.2122ZM79.8587 19.2122L81.1796 17.4521L80.8116 17.1759L79.4907 18.9361L79.8587 19.2122ZM83.8145 13.9279C83.8145 15.569 82.569 16.9195 80.9719 17.0852L81.0193 17.5428C82.8485 17.3531 84.2746 15.8072 84.2746 13.9279H83.8145ZM80.6401 10.7535C82.3933 10.7535 83.8145 12.1747 83.8145 13.9279H84.2746C84.2746 11.9206 82.6474 10.2934 80.6401 10.2934V10.7535ZM77.237 10.7535H80.6401V10.2934H77.237V10.7535Z",
    fill: "#648AEB",
    mask: "url(#path-48-inside-1_3572_21516)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9384 12.2266C77.8101 12.2266 76.896 13.1408 76.896 14.2692C76.896 15.3976 77.8101 16.3119 78.9384 16.3119C80.0667 16.3119 80.9808 15.3976 80.9808 14.2692C80.9808 13.1408 80.0667 12.2266 78.9384 12.2266ZM80.1243 14.4999C80.1243 14.5542 80.0799 14.5987 80.0255 14.5987H79.2678V15.3565C79.2678 15.4108 79.2234 15.4553 79.169 15.4553H78.7078C78.6535 15.4553 78.609 15.4108 78.609 15.3565V14.5987H77.8513C77.797 14.5987 77.7525 14.5542 77.7525 14.4999V14.0386C77.7525 13.9842 77.797 13.9398 77.8513 13.9398H78.609V13.182C78.609 13.1276 78.6535 13.0832 78.7078 13.0832H79.169C79.2234 13.0832 79.2678 13.1276 79.2678 13.182V13.9398H80.0255C80.0799 13.9398 80.1243 13.9842 80.1243 14.0386V14.4999Z",
    fill: "url(#paint1_linear_3572_21516)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3572_21516)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-51-inside-2_3572_21516",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2424 15.2812C18.3832 15.2812 16.876 16.7885 16.876 18.6477C16.876 20.3877 18.196 21.8194 19.8893 21.9959L21.189 23.7276C21.557 24.2181 22.2929 24.2181 22.661 23.7276L23.9606 21.9959C25.6539 21.8195 26.9741 20.3878 26.9741 18.6477C26.9741 16.7885 25.4669 15.2812 23.6076 15.2812H20.2424Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2424 15.2812C18.3832 15.2812 16.876 16.7885 16.876 18.6477C16.876 20.3877 18.196 21.8194 19.8893 21.9959L21.189 23.7276C21.557 24.2181 22.2929 24.2181 22.661 23.7276L23.9606 21.9959C25.6539 21.8195 26.9741 20.3878 26.9741 18.6477C26.9741 16.7885 25.4669 15.2812 23.6076 15.2812H20.2424Z",
    fill: "#3063E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8893 21.9959L20.2573 21.7197L20.1368 21.5591L19.937 21.5382L19.8893 21.9959ZM21.189 23.7276L20.8209 24.0038H20.8209L21.189 23.7276ZM22.661 23.7276L22.293 23.4515L22.661 23.7276ZM23.9606 21.9959L23.9129 21.5383L23.7131 21.5591L23.5926 21.7197L23.9606 21.9959ZM17.3361 18.6477C17.3361 17.0426 18.6373 15.7414 20.2424 15.7414V14.8211C18.1291 14.8211 16.4159 16.5344 16.4159 18.6477H17.3361ZM19.937 21.5382C18.4757 21.3859 17.3361 20.1496 17.3361 18.6477H16.4159C16.4159 20.6258 17.9164 22.2528 19.8416 22.4535L19.937 21.5382ZM19.5213 22.272L20.8209 24.0038L21.557 23.4515L20.2573 21.7197L19.5213 22.272ZM20.8209 24.0038C21.3731 24.7395 22.4768 24.7395 23.029 24.0038L22.293 23.4515C22.1089 23.6967 21.741 23.6967 21.557 23.4515L20.8209 24.0038ZM23.029 24.0038L24.3286 22.2721L23.5926 21.7197L22.293 23.4515L23.029 24.0038ZM26.514 18.6477C26.514 20.1497 25.3743 21.386 23.9129 21.5383L24.0082 22.4535C25.9335 22.2529 27.4342 20.6259 27.4342 18.6477H26.514ZM23.6076 15.7414C25.2128 15.7414 26.514 17.0426 26.514 18.6477H27.4342C27.4342 16.5344 25.721 14.8211 23.6076 14.8211V15.7414ZM20.2424 15.7414H23.6076V14.8211H20.2424V15.7414Z",
    fill: "url(#paint2_linear_3572_21516)",
    mask: "url(#path-51-inside-2_3572_21516)"
  }))), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1353,
    y: 17.191,
    width: 3.57915,
    height: 3.57965,
    stroke: "#3063E4",
    strokeWidth: 0.460106
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9445 18.9808C23.9445 20.0964 23.0403 21.0007 21.9249 21.0007C20.8095 21.0007 19.9053 20.0964 19.9053 18.9808C19.9053 17.8653 20.8095 16.9609 21.9249 16.9609C23.0403 16.9609 23.9445 17.8653 23.9445 18.9808ZM21.6913 20.0503L23.1897 18.5517C23.2406 18.5008 23.2406 18.4183 23.1897 18.3674L23.0055 18.1831C22.9546 18.1322 22.8721 18.1322 22.8212 18.1831L21.5992 19.4053L21.0286 18.8347C20.9777 18.7838 20.8952 18.7838 20.8443 18.8347L20.6601 19.019C20.6092 19.0699 20.6092 19.1524 20.6601 19.2033L21.507 20.0503C21.5579 20.1012 21.6404 20.1012 21.6913 20.0503Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3572_21516)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-55-inside-3_3572_21516",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2756 39.2695C55.1955 39.2695 54.3198 40.1452 54.3198 41.2253C54.3198 42.2407 55.0936 43.0753 56.0836 43.1718C56.1048 43.2101 56.1291 43.2477 56.1566 43.2843L56.517 43.7647C56.8851 44.2552 57.621 44.2552 57.9891 43.7647L58.3496 43.2843C58.3771 43.2477 58.4013 43.2101 58.4225 43.1718C59.4126 43.0754 60.1864 42.2407 60.1864 41.2253C60.1864 40.1452 59.3108 39.2695 58.2306 39.2695H56.2756Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2756 39.2695C55.1955 39.2695 54.3198 40.1452 54.3198 41.2253C54.3198 42.2407 55.0936 43.0753 56.0836 43.1718C56.1048 43.2101 56.1291 43.2477 56.1566 43.2843L56.517 43.7647C56.8851 44.2552 57.621 44.2552 57.9891 43.7647L58.3496 43.2843C58.3771 43.2477 58.4013 43.2101 58.4225 43.1718C59.4126 43.0754 60.1864 42.2407 60.1864 41.2253C60.1864 40.1452 59.3108 39.2695 58.2306 39.2695H56.2756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0836 43.1718L56.285 43.0606L56.2265 42.9545L56.1059 42.9428L56.0836 43.1718ZM56.1566 43.2843L56.3406 43.1462L56.1566 43.2843ZM56.517 43.7647L56.701 43.6266L56.517 43.7647ZM57.9891 43.7647L57.8051 43.6266L57.9891 43.7647ZM58.3496 43.2843L58.1655 43.1462V43.1462L58.3496 43.2843ZM58.4225 43.1718L58.4002 42.9428L58.2796 42.9545L58.2211 43.0606L58.4225 43.1718ZM54.5499 41.2253C54.5499 40.2722 55.3225 39.4996 56.2756 39.4996V39.0395C55.0684 39.0395 54.0898 40.0181 54.0898 41.2253H54.5499ZM56.1059 42.9428C55.2326 42.8577 54.5499 42.1211 54.5499 41.2253H54.0898C54.0898 42.3602 54.9546 43.2929 56.0613 43.4007L56.1059 42.9428ZM55.8823 43.283C55.9086 43.3307 55.9387 43.3773 55.9726 43.4224L56.3406 43.1462C56.3194 43.1181 56.301 43.0894 56.285 43.0606L55.8823 43.283ZM55.9726 43.4224L56.333 43.9028L56.701 43.6266L56.3406 43.1462L55.9726 43.4224ZM56.333 43.9028C56.7932 44.5159 57.7129 44.5159 58.1731 43.9028L57.8051 43.6266C57.529 43.9944 56.9771 43.9944 56.701 43.6266L56.333 43.9028ZM58.1731 43.9028L58.5336 43.4224L58.1655 43.1462L57.8051 43.6266L58.1731 43.9028ZM58.5336 43.4224C58.5674 43.3773 58.5975 43.3307 58.6238 43.283L58.2211 43.0606C58.2051 43.0894 58.1867 43.1181 58.1655 43.1462L58.5336 43.4224ZM59.9563 41.2253C59.9563 42.1211 59.2736 42.8578 58.4002 42.9428L58.4447 43.4008C59.5516 43.293 60.4165 42.3603 60.4165 41.2253H59.9563ZM58.2306 39.4996C59.1837 39.4996 59.9563 40.2722 59.9563 41.2253H60.4165C60.4165 40.0181 59.4378 39.0395 58.2306 39.0395V39.4996ZM56.2756 39.4996H58.2306V39.0395H56.2756V39.4996Z",
    fill: "#648AEB",
    mask: "url(#path-55-inside-3_3572_21516)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2534 40.2461C56.6052 40.2461 56.0801 40.7713 56.0801 41.4196C56.0801 42.0678 56.6052 42.593 57.2534 42.593C57.9015 42.593 58.4267 42.0678 58.4267 41.4196C58.4267 40.7713 57.9015 40.2461 57.2534 40.2461ZM57.9347 41.552C57.9347 41.5833 57.9091 41.6088 57.8779 41.6088H57.4426V42.0441C57.4426 42.0754 57.4171 42.1009 57.3859 42.1009H57.1209C57.0897 42.1009 57.0641 42.0754 57.0641 42.0441V41.6088H56.6289C56.5977 41.6088 56.5721 41.5833 56.5721 41.552V41.2871C56.5721 41.2558 56.5977 41.2303 56.6289 41.2303H57.0641V40.795C57.0641 40.7637 57.0897 40.7382 57.1209 40.7382H57.3859C57.4171 40.7382 57.4426 40.7637 57.4426 40.795V41.2303H57.8779C57.9091 41.2303 57.9347 41.2558 57.9347 41.2871V41.552Z",
    fill: "url(#paint3_linear_3572_21516)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 12.5051,
    height: 3.46516,
    rx: 1.73258,
    transform: "matrix(0.707063 0.707151 -0.707063 0.707151 62.8809 47.0469)",
    fill: "#3063E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6348 52.1892C61.3128 52.1892 65.9157 47.5858 65.9157 41.9071C65.9157 36.2285 61.3128 31.625 55.6348 31.625C49.9569 31.625 45.354 36.2285 45.354 41.9071C45.354 47.5858 49.9569 52.1892 55.6348 52.1892ZM55.6349 50.4471C60.3504 50.4471 64.1732 46.6239 64.1732 41.9078C64.1732 37.1916 60.3504 33.3684 55.6349 33.3684C50.9193 33.3684 47.0966 37.1916 47.0966 41.9078C47.0966 46.6239 50.9193 50.4471 55.6349 50.4471Z",
    fill: "url(#paint4_linear_3572_21516)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.626 3.32173C102.626 3.32173 104.113 2.31283 105.455 4.10713C106.797 5.90144 106.314 7.6254 106.035 9.23647C105.756 10.8339 104.403 14.4892 104.977 16.0994C105.554 17.7094 104.819 18.5478 104.819 18.5478C104.819 18.5478 100.202 19.7969 100.742 12.4595C101.279 5.12199 102.626 3.32173 102.626 3.32173Z",
    fill: "#363957"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.558 85.387C87.558 85.387 85.5514 88.0758 85.8263 88.5047C86.1012 88.9307 88.2127 88.9899 89.4965 88.5047C90.7832 88.0166 90.8144 84.8622 91.3954 83.5079C91.6391 82.9408 91.1176 81.2677 90.3864 81.1463C89.6524 81.025 88.856 81.3805 88.856 81.3805C88.856 81.3805 89.6155 83.2878 87.558 85.387Z",
    fill: "#47558D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.594 81.3886C88.594 81.3886 88.1375 82.4982 87.972 83.5587C87.8342 84.4388 86.4249 86.3028 86.4923 86.5406C86.5597 86.7757 88.3427 86.9889 89.0719 86.3821C89.798 85.7726 90.2667 84.0042 90.4291 82.9437C90.5762 81.9598 90.7661 81.4733 90.7661 81.4733C90.7661 81.4733 89.2894 80.7408 88.594 81.3886Z",
    fill: "#DBA585"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4561 83.1914V86.0885H90.7663V83.8504L91.4561 83.1914Z",
    fill: "#47558D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.455 85.4315C104.455 85.4315 102.519 88.0757 102.794 88.5046C103.069 88.9307 105.18 88.99 106.466 88.5046C107.75 88.0164 107.781 84.8615 108.362 83.5069C108.606 82.9397 108.084 81.2663 107.353 81.145C106.619 81.0236 105.761 81.4046 105.761 81.4046C105.761 81.4046 106.512 83.332 104.455 85.4315Z",
    fill: "#47558D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.009 81.4888C106.009 81.4888 105.859 82.6874 105.62 83.5343C105.381 84.3812 104.087 86.3076 104.149 86.543C104.21 86.7757 105.831 86.9867 106.49 86.3861C107.15 85.7827 107.661 84.0376 107.723 82.9823C107.781 81.9271 107.572 81.2399 107.572 81.2399C107.572 81.2399 106.641 80.8476 106.009 81.4888Z",
    fill: "#DBA585"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.411 83.0312V85.9284H107.721V83.6902L108.411 83.0312Z",
    fill: "#47558D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0426 37.2677C96.0426 37.2677 94.2916 45.2378 93.8913 47.2451C93.4881 49.2518 92.3621 58.9718 92.2412 60.6236C92.1202 62.2765 90.4153 68.5041 90.496 69.0935C90.5766 69.6843 87.8696 81.3981 87.8696 81.3981C87.8696 81.3981 90.6573 82.1366 91.1238 81.6405C91.5241 81.2149 95.5242 70.5037 95.5242 67.553C95.5242 63.4743 98.3609 58.1544 98.692 57.2168C101.762 48.5062 101.969 46.1655 102.453 45.6138C102.934 45.0633 102.977 45.9541 103.259 47.174C103.539 48.3943 104.141 58.9399 104.504 60.2777C104.866 61.6155 104.584 66.1411 104.786 68.4232C104.987 70.7056 105.218 80.9302 105.218 80.9302C105.218 80.9302 107.237 81.3868 108.193 80.9471C108.469 80.8202 109.166 69.5566 109.206 66.8407C109.247 64.126 109.29 60.382 109.368 59.208C110.114 47.9568 111.945 46.349 109.06 38.3865C103.663 23.4771 96.0426 37.2677 96.0426 37.2677Z",
    fill: "#363957"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9043 17.5148C97.0977 17.3225 95.7636 17.9202 92.8777 19.6275C89.6353 21.5455 89.6752 21.4947 90.1299 20.9147C90.145 20.8954 90.1606 20.8756 90.1765 20.8552L95.9203 13.1534L93.7025 11.9766C90.0076 15.645 84.645 22.8856 84.4933 24.1164C84.4842 24.1908 84.4747 24.2647 84.4653 24.3381C84.2929 25.6821 84.1482 26.8108 86.5161 26.3117C88.1162 25.9745 92.3476 24.8098 95.204 23.607C95.3765 24.3693 95.6795 25.2189 96.0751 26.1302C96.576 27.2808 96.517 27.9898 96.4525 28.7653C96.4049 29.3371 96.3543 29.9451 96.5229 30.793C96.7996 32.1862 96.2227 34.9823 95.8219 36.9248L95.8219 36.9248C95.6477 37.7693 95.5067 38.4525 95.4837 38.7889C95.4105 39.8994 107.188 40.5733 109.498 38.5503C109.498 38.5503 108.109 33.6823 107.811 33.1887C107.512 32.6961 106.873 30.3002 107.143 29.6092C107.368 29.0392 108.646 24.9432 109.086 23.5252C109.104 23.5451 109.122 23.5649 109.14 23.5846C109.399 23.8781 109.722 24.2308 110.085 24.6272L110.085 24.6273C111.927 26.639 114.797 29.7746 115.638 31.982C116.648 34.6232 118.378 39.184 118.378 39.184L121.251 38.7717C121.251 38.7717 119.602 33.933 118.433 31.4357C117.989 30.4871 117.525 29.4442 117.1 28.4873L117.1 28.4873C116.405 26.9246 115.811 25.5915 115.575 25.2738C115.451 25.1079 115.149 24.6534 114.777 24.091C114 22.9192 112.913 21.2792 112.473 20.8055C112.28 20.5974 112.092 20.2826 111.872 19.9132C111.35 19.0385 110.647 17.8582 109.255 17.0673C108.513 16.6453 107.66 16.5354 106.883 16.5627C106.352 16.4436 105.831 16.3494 105.403 16.2719C104.96 16.1917 104.616 16.1294 104.462 16.076C103.89 15.8786 102.232 15.7924 101.066 15.9649C101.066 15.9649 99.2772 16.804 98.6576 16.9269C98.5007 16.9584 98.2292 17.1811 97.9043 17.5148Z",
    fill: "#3063E4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.629 20.1423L99.1809 18.7762L100.437 15.1758C100.437 15.1758 100.861 17.1806 100.629 20.1423Z",
    fill: "#CFC3BC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.008 13.9737C100.008 13.9737 100.354 17.1678 100.282 18.2078C100.282 18.2078 102.09 20.0218 104.146 16.0916C104.146 16.0916 103.283 14.4708 103.933 12.2638C104.583 10.0578 100.008 13.9737 100.008 13.9737Z",
    fill: "#DBA585"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.306 18.0156V20.1045L102.656 18.1423L100.306 18.0156Z",
    fill: "#DBA585"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.698 20.1439L101.487 18.9925L104.146 15.8672L103.981 17.7208L100.698 20.1439Z",
    fill: "#CFC3BC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.2614 18.7634L97.956 19.113L100.163 15.6641L99.2614 18.7634Z",
    fill: "#F3E4DC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.388 19.0716L102.567 20.8337L104.974 16.2296L104.206 15.8672L101.388 19.0716Z",
    fill: "#F3E4DC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.008 14.479L100.073 15.1644C100.073 15.1644 101.538 15.4693 103.457 12.9688C103.457 12.9688 102.096 14.7416 100.008 14.479Z",
    fill: "#997761"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.307 14.4884C99.7331 14.467 98.1375 14.2773 97.3508 10.54C96.3896 5.97437 98.5143 3.60642 100.334 3.16751C102.154 2.7286 103.833 3.3719 104.766 5.75844C104.766 5.75844 105.448 7.61908 104.343 10.9333C103.237 14.2472 100.919 14.511 100.307 14.4884Z",
    fill: "#DBA686"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.982 5.80366C101.982 5.80366 99.5617 5.96387 97.3088 9.55366C97.3088 9.55366 96.2578 5.23478 99.0101 3.26424C101.765 1.29253 103.692 2.98723 104.364 3.84623C104.364 3.84623 105.327 4.08188 105.357 6.02213C105.388 7.96267 106.62 10.8921 103.922 12.2807C103.922 12.2807 104.177 10.0652 103.939 9.55891C103.703 9.05236 102.877 9.39375 101.982 5.80366Z",
    fill: "#363957"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.62 9.147C103.713 8.82135 103.962 8.68957 104.098 9.03892C104.236 9.38799 104.073 10.7411 103.707 10.8892C103.341 11.0368 103.435 9.80647 103.62 9.147Z",
    fill: "#DBA686"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.889 42.5679C121.889 42.5679 121.965 42.2039 121.933 42.0246C121.933 42.0246 121.85 41.7064 121.803 41.4752C121.787 41.4026 121.776 41.3385 121.771 41.2959C121.756 41.1187 121.769 40.7247 121.627 40.3112C121.489 39.8976 120.864 38.4961 120.864 38.4961L119.727 38.8952L118.697 38.9126C118.697 38.9126 118.276 41.5625 118.367 41.9655C118.378 42.0039 118.386 42.0423 118.399 42.0776C118.506 42.4102 118.707 42.6051 118.781 42.773C118.807 42.8342 119.113 43.4201 119.29 43.451C119.533 43.4948 119.719 43.4105 119.831 43.2666C119.831 43.2666 120.315 43.3269 120.587 43.1224C120.587 43.1224 121.031 43.194 121.309 42.8279C121.309 42.8279 121.763 42.8435 121.889 42.5679Z",
    fill: "#DCA787"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.606 11.3259L98.525 11.3654L98.5063 9.89879L101.587 9.85938L101.606 11.3259Z",
    fill: "#373A38"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.261 13.5576L103.271 9.83627L101.587 9.85781L100.534 13.6053L104.261 13.5576Z",
    fill: "#404241"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.816 13.209L103.081 9.48442C103.081 9.48442 102.8 9.39909 102.407 9.40412C102.018 9.40909 101.852 9.50013 101.852 9.50013L101.096 13.2438L103.816 13.209Z",
    fill: "#404241"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1236 13.2715L98.388 9.54692C98.388 9.54692 98.1071 9.4616 97.7147 9.46662C97.3255 9.4716 97.16 9.56263 97.16 9.56263L96.4036 13.3063L99.1236 13.2715Z",
    fill: "#404241"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6317 13.6201L98.6419 9.89877L96.9585 9.9203L95.9043 13.6678L99.6317 13.6201Z",
    fill: "#404241"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6319 13.6183C99.6189 12.6037 98.774 11.7919 97.7448 11.8051C96.7155 11.8183 95.8915 12.6514 95.9045 13.666C95.9174 14.6806 96.7625 15.4924 97.7918 15.4793C98.821 15.4661 99.6449 14.6329 99.6319 13.6183Z",
    fill: "#555957"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.261 13.5597C104.248 12.5451 103.403 11.7333 102.374 11.7465C101.345 11.7597 100.521 12.5928 100.534 13.6074C100.547 14.622 101.392 15.4338 102.421 15.4207C103.45 15.4075 104.274 14.5743 104.261 13.5597Z",
    fill: "#555957"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1507 13.6247C99.1411 12.8719 98.5143 12.2696 97.7506 12.2794C96.9869 12.2892 96.3757 12.9072 96.3854 13.66C96.395 14.4128 97.0218 15.0151 97.7855 15.0053C98.5492 14.9955 99.1604 14.3775 99.1507 13.6247Z",
    fill: "#EEF6FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.78 13.5661C103.77 12.8133 103.144 12.211 102.38 12.2208C101.617 12.2306 101.005 12.8486 101.015 13.6014C101.024 14.3543 101.651 14.9565 102.415 14.9467C103.179 14.9369 103.79 14.3189 103.78 13.5661Z",
    fill: "#EEF6FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.376 13.6576C103.409 13.6571 103.44 13.6395 103.456 13.609C103.478 13.5652 103.461 13.5116 103.416 13.4894L101.948 12.7521C101.935 12.7454 101.921 12.7423 101.906 12.7425C101.874 12.7429 101.843 12.7605 101.827 12.791C101.805 12.8348 101.822 12.8884 101.867 12.9106L103.334 13.6479C103.348 13.6546 103.362 13.6577 103.376 13.6576Z",
    fill: "#CBE7DC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.385 14.3558C103.418 14.3554 103.45 14.3372 103.465 14.3061C103.487 14.2621 103.469 14.2087 103.424 14.1871L101.306 13.1622C101.293 13.1557 101.279 13.1529 101.266 13.1531C101.233 13.1535 101.201 13.1716 101.186 13.2028C101.164 13.2468 101.182 13.3002 101.227 13.3218L103.345 14.3468C103.358 14.3531 103.372 14.356 103.385 14.3558Z",
    fill: "#CBE7DC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6874 13.7513C98.7197 13.7509 98.7509 13.7332 98.7666 13.7028C98.7892 13.6591 98.7716 13.6056 98.7273 13.5832L97.2595 12.8461C97.2458 12.8392 97.2315 12.836 97.2173 12.8362C97.1849 12.8366 97.1538 12.8545 97.1381 12.8849C97.1154 12.9286 97.133 12.9821 97.1775 13.0043L98.6453 13.7416C98.6587 13.7483 98.6731 13.7515 98.6874 13.7513Z",
    fill: "#CBE7DC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.696 14.4459C98.7289 14.4455 98.7603 14.4272 98.7759 14.396C98.7978 14.3519 98.7794 14.2988 98.7347 14.277L96.6169 13.252C96.6036 13.2457 96.5897 13.2427 96.5759 13.2429C96.5431 13.2433 96.5116 13.2616 96.4961 13.2926C96.4742 13.3367 96.4926 13.39 96.5373 13.4116L98.6551 14.4366C98.6683 14.4431 98.6823 14.4461 98.696 14.4459Z",
    fill: "#CBE7DC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7623 14.3524L95.2506 13.9385L95.9987 14.0891C95.9987 14.0891 95.2799 11.9934 97.5914 11.5827C98.0802 11.496 98.2911 11.4446 98.6272 11.3746C99.0257 11.2913 99.085 9.91537 97.9172 9.90542C96.25 9.89148 95.2506 10.8237 95.2506 10.8237L94.6072 11.2926L93.0425 12.8349L94.7623 14.3524Z",
    fill: "#DBA585"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3572_21516",
    x: 68.3112,
    y: 6.84259,
    width: 21.2545,
    height: 19.9605,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84043
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.76064
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_21516"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_21516",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3572_21516",
    x: 11.3547,
    y: 11.6004,
    width: 21.1407,
    height: 19.8551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84043
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.76064
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_21516"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_21516",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3572_21516",
    x: 48.7985,
    y: 35.5887,
    width: 16.9093,
    height: 15.9058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.84043
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.76064
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3572_21516"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3572_21516",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3572_21516",
    x1: -0.000013303,
    y1: -15.4441,
    x2: 157.441,
    y2: 36.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8ECDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#EAEFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#FDEFCE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3572_21516",
    x1: 76.896,
    y1: 6.53388,
    x2: 82.1231,
    y2: 7.06845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24B275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#3063E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#F0AE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3572_21516",
    x1: 16.876,
    y1: 2.99911,
    x2: 29.7563,
    y2: 4.50842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91D8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#97B1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#F7D780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3572_21516",
    x1: 56.0801,
    y1: 36.9758,
    x2: 59.0829,
    y2: 37.2829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24B275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#3063E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#F0AE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3572_21516",
    x1: 45.354,
    y1: 2.96997,
    x2: 71.6657,
    y2: 5.66083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91D8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#97B1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#F7D780"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadFinderUpsell);
export default __webpack_public_path__ + "static/media/leadFinderUpsell.bd33445634caf8658d157fc258993c3b.svg";
export { ForwardRef as ReactComponent };